<p-button
  data-testid="list-create"
  size="small"
  label="Creează locker"
  icon="pi pi-plus"
  iconPos="left"
  (click)="confirmLockerCreate()"
></p-button>

<form class="grid mt-1" [formGroup]="filtersForm">
  <div class="col-12 lg:col-3">
    <span class="font-bold block mb-1">Lockere</span>
    <p-multiSelect
      data-testid="filter-lockerIdentifiers"
      formControlName="lockerIdentifiers"
      optionLabel="name"
      optionValue="id"
      styleClass="w-full"
      appendTo="body"
      placeholder="Caută lockere"
      filterBy="id,name"
      [showClear]="true"
      [options]="lockers()"
      [loading]="!lockers()"
    >
      <ng-template let-locker pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>
            <small class="text-gray-400">#{{ locker?.id }}</small>
            <p class="m-0">{{ locker?.name }}</p>
          </div>
        </div>
      </ng-template>
    </p-multiSelect>
  </div>

  <div class="flex align-items-center gap-2 col-12 lg:col-3">
    <p-checkbox
      data-testid="filter-isActive"
      class="mt-1"
      formControlName="isActive"
      label="Active"
      [binary]="true"
    ></p-checkbox>

    <p-checkbox
      data-testid="filter-isConfigured"
      class="mt-1"
      formControlName="isConfigured"
      label="Configurate"
      [binary]="true"
    ></p-checkbox>

    <p-checkbox
      data-testid="filter-autoRefresh"
      class="mt-1"
      [formControl]="autoRefresh"
      label="Auto refresh"
      [binary]="true"
    ></p-checkbox>
  </div>
</form>

<p-table
  data-testid="list-table"
  styleClass="p-datatable-sm w-full"
  currentPageReportTemplate="{first} - {last} din {totalRecords} lockere"
  paginatorPosition="both"
  [totalRecords]="totalCount()"
  [lazy]="true"
  [paginator]="true"
  [rows]="filtersForm.get('pageSize')?.value"
  [value]="data()"
  [rowsPerPageOptions]="[25, 50, 100]"
  [showCurrentPageReport]="true"
  (onPage)="pageChanged($event)"
>
  <ng-template pTemplate="header">
    @if (loading()) {
      <tr>
        <td colspan="7">
          <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
        </td>
      </tr>
    }
    <tr>
      <th>Locker</th>
      <th class="text-center">Versiune soft</th>
      <th class="text-center">Structură</th>
      <th class="text-center">Evenimente</th>
      <th class="text-center">Număr de restarturi</th>
      <th class="text-center">Extras</th>
      <th class="text-center">Uși</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-locker>
    <tr
      class="hover:surface-200 cursor-pointer"
      [attr.data-testid]="'list-row-' + locker.externalIdentifier"
      (click)="openLockerDetails(locker)"
    >
      <td>
        <div class="flex flex-column">
          <div>
            <small class="text-gray-400">#{{ locker.externalIdentifier }}</small><br>
            <b>{{ locker.name }}</b>
            <br>
            <small>{{ formatLockerAddress(locker.addressParts) }}</small>
          </div>
          <div class="flex align-items-center gap-1">
            <p-tag
              [value]="locker.state.isConfigured ? 'Configurat' : 'Neconfigurat'"
              [severity]="locker.state.isConfigured ? 'success' : 'danger'"
            ></p-tag>
            <p-tag
              [value]="locker.state.isOnline ? 'Online' : 'Offline'"
              [severity]="locker.state.isOnline ? 'success' : 'danger'"
            ></p-tag>
            <p-tag
              [value]="locker.state.isActive ? 'Activ' : 'Inactiv'"
              [severity]="locker.state.isActive ? 'success' : 'danger'"
            ></p-tag>
          </div>
        </div>
      </td>
      <td
        class="text-center"
        [class.text-red-500]="!locker.softwareVersion.isLatest"
      >{{ locker.softwareVersion.name }}({{ locker.softwareVersion.code }})</td>
      <td class="text-center">
        <p class="m-0">Echipamente: {{ locker.equipments.count }}</p>
        <p class="m-0">Module: {{ locker.modules.count }}</p>
      </td>
      <td [class.text-orange-500]="locker?.recentProcedures?.taggedCount > 0" class="text-center">
        {{ locker?.recentProcedures?.totalCount }} total
        /
        {{ locker?.recentProcedures?.taggedCount }} tag
      </td>
      <td class="text-center" [class.text-red-500]="locker?.restarts?.count > 0">{{ locker?.restarts?.count }}</td>
      <td class="text-center">
        @if (locker?.heartbeat) {
          <p class="m-0">
            {{ locker?.heartbeat?.count }}
            /
            {{ formatTimeInMilliseconds(locker?.heartbeat?.data?.uptime) }}
            @if (locker?.heartbeat?.lastPingAt) {
              /
              <!-- Pass 2 to the function to check if 3 minutes has passed -->
              <span
                [class.text-red-500]="lockerExtras()[locker.externalIdentifier]?.isOldHeartbeat"
              >{{ formatDate(locker?.heartbeat?.lastPingAt) }}</span>
            }
          </p>
        } @else {
          <p class="m-0 text-gray-400">Nu există date despre heartbeat</p>
        }
        @if (locker?.heartbeat?.data?.memory) {
          <p
            [class.text-red-500]="lockerExtras()[locker.externalIdentifier]?.memoryFreePercentage >= 0 && lockerExtras()[locker.externalIdentifier]?.memoryFreePercentage <= 20"
            [class.text-orange-500]="lockerExtras()[locker.externalIdentifier]?.memoryFreePercentage > 20 && lockerExtras()[locker.externalIdentifier]?.memoryFreePercentage <= 60"
            [class.text-green-500]="lockerExtras()[locker.externalIdentifier]?.memoryFreePercentage > 60"
            class="m-0"
          >
            Memory:
            {{ formatBytes(locker?.heartbeat?.data?.memory?.total - locker?.heartbeat?.data?.memory?.available) }} used,
            {{ formatBytes(locker?.heartbeat?.data?.memory?.available) }} free
            /
            {{ formatBytes(locker?.heartbeat?.data?.memory?.total) }}
          </p>
        }
        @if (locker?.heartbeat?.data?.storage) {
          <p
            [class.text-red-500]="lockerExtras()[locker.externalIdentifier].storageFreePercentage >= 0 && lockerExtras()[locker.externalIdentifier].storageFreePercentage <= 20"
            [class.text-orange-500]="lockerExtras()[locker.externalIdentifier].storageFreePercentage > 20 && lockerExtras()[locker.externalIdentifier].storageFreePercentage <= 60"
            [class.text-green-500]="lockerExtras()[locker.externalIdentifier].storageFreePercentage > 60"
            class="m-0"
          >
            Storage:
            {{ formatBytes(locker?.heartbeat?.data?.storage?.total - locker?.heartbeat?.data?.storage?.available) }} used,
            {{ formatBytes(locker?.heartbeat?.data?.storage?.available) }} free
            /
            {{ formatBytes(locker?.heartbeat?.data?.storage?.total) }}
          </p>
        }
        <p class="m-0">
          <span
            [class.text-red-500]="!locker?.heartbeat?.data?.messageBroker?.available"
            [class.text-green-500]="locker?.heartbeat?.data?.messageBroker?.available"
          >Broker: {{ locker?.heartbeat?.data?.messageBroker?.available ? "Activ" : "Inactiv" }}</span>
          /
          <span
            [class.text-red-500]="!locker?.heartbeat?.data?.printer?.available"
            [class.text-green-500]="locker?.heartbeat?.data?.printer?.available"
          >Imprimanta: {{ locker?.heartbeat?.data?.printer?.available ? "Ok" : "NOK" }}</span>
          /
          <span
            [class.text-red-500]="!locker?.heartbeat?.data?.camera?.available"
            [class.text-green-500]="locker?.heartbeat?.data?.camera?.available"
          >Camera: {{ locker?.heartbeat?.data?.camera?.available ? "Ok" : "NOK" }}</span>
        </p>
        <p class="m-0">
          Evenimente cu eroare:
          <span [class.text-red-500]="locker?.heartbeat?.data?.events?.failedCount > 0">{{ locker?.heartbeat?.data?.events?.failedCount }}</span>
          /
          <span
            [class.text-red-500]="locker?.heartbeat?.data?.doors?.failedCount> 0"
          >
            Erori comm. usi:
            {{ locker?.heartbeat?.data?.doors?.failedCount }}
          </span>

        </p>
      </td>
      <td>
        <div class="flex flex-nowrap align-items-center gap-2">
          <span class="material-symbols-rounded text-orange-500">warning</span>
          <span class="m-0" [class.text-red-500]="locker.boxes.errored.count > 0">Cu eroare: {{ locker.boxes.errored.count }}</span>
        </div>
        <div class="flex flex-nowrap align-items-center gap-2">
          <span class="material-symbols-rounded text-red-500">cancel</span>
          <span class="m-0" [class.text-red-500]="locker.boxes.broken.count > 0">
            Stricate: {{ locker.boxes.broken.count }}
            @let brokenDoorsMatchValue = getHashMatchValue(locker, "BROKEN_DOORS");
            @if (brokenDoorsMatchValue) {
              @switch (brokenDoorsMatchValue) {
                @case ("MATCH") {
                  <span class="text-green-500">(SINCRONIZAT)</span>
                }

                @case ("DRIFT") {
                  <span class="text-red-500">(DESINCRONIZAT)</span>
                }

                @case ("UNKNOWN") {
                  <span class="text-orange-500">(NECUNOSCUT)</span>
                }
              }
            }
          </span>
        </div>
        <div class="flex flex-nowrap align-items-center gap-2">
          <span class="material-symbols-rounded">lock_open</span>
          <span class="m-0">Deschise: {{ locker.boxes.open.count }}</span>
        </div>
        <div class="flex flex-nowrap align-items-center gap-2">
          <span class="material-symbols-rounded">battery_full</span>
          <span class="m-0">Full: {{ locker.boxes.full.count }}</span>
        </div>
        <div class="flex flex-nowrap align-items-center gap-2">
          <span class="material-symbols-rounded">calendar_clock</span>
          <span class="m-0">Rezervate: {{ locker.boxes.reserved.count }}</span>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>